import { useEffect, useState } from 'react';

/**
 * Mini hash router pro site marketing.
 *
 * Hash routing porque o site é estático e SSG fica caro pra um MVP.
 * Quando o user navega: `#/privacidade` muda a rota sem reload. Reload
 * mantém a página. Browser back/forward funcionam.
 *
 * Compatível com âncoras (#how, #faq, #roadmap) — qualquer hash que NÃO
 * comece com `/` é tratado como âncora pelo browser default.
 */

export type RoutePath =
  | '/'
  | '/privacidade'
  | '/termos'
  | '/cookies'
  | '/atualizacoes';

export function useRoute(): RoutePath {
  const [path, setPath] = useState<RoutePath>(() => parse(window.location.hash));

  useEffect(() => {
    function onHash() {
      setPath(parse(window.location.hash));
      // Pra páginas legais, sobe pro topo no acesso direto
      if (window.location.hash.startsWith('#/')) {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }
    }
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  return path;
}

function parse(hash: string): RoutePath {
  if (!hash.startsWith('#/')) return '/';
  const stripped = hash.slice(1);
  switch (stripped) {
    case '/privacidade':
      return '/privacidade';
    case '/termos':
      return '/termos';
    case '/cookies':
      return '/cookies';
    case '/atualizacoes':
      return '/atualizacoes';
    default:
      return '/';
  }
}
